export default function NYTimes() {
    return (
        <>
            <h1 className="text-4xl font-bold mb-5 pr-6">
                New York Times
            </h1>

            <p className="mb-4">
                Students can obtain free New York Times access from the Palo Alto City Library. Read the instructions below on how to access your PAUSD-provided Palo Alto Library account.
            </p>
            <a href="https://library.cityofpaloalto.org/resources-types/magazine/#resource-item-245866" target="_blank" rel="noopener noreferrer">
                Register for an New York Times subscription →
            </a>
        </>
    )
}
